import setRoamingSignatureInStore from '../actions/setRoamingSignatureInStore';
import setDefaultSignatureName from '../actions/setDefaultSignatureName';
import { getStore } from '../store/signatureStore';
import { getUserConfiguration } from 'owa-session-store';
import {
    saveRoamingSignature,
    saveRoamingSignatureList,
    saveDefaultRoamingSignature,
    saveDefaultReplyRoamingSignature,
} from '../service/saveRoamingSignature';
import { SignatureBlock } from '../store/schema/SignatureStore';
import loc from 'owa-localize';
import { defaultOwaSignatureName } from './populateFirstSignature.locstring.json';

/**
 * This is the logic to migrate the existing signature to Roaming signautre
 * Logic:
 *       If the user has legacy signature then automatically populate the first
 * signature for user. This will cut over user from legacy signature system to
 * roaming signature automatically.
 */
export default function populatefirstSignature() {
    const { roamingSignatureMap, legacySignature } = getStore();
    const { AutoAddSignature, AutoAddSignatureOnReply } = getUserConfiguration().UserOptions;

    if (!legacySignature.html?.value) {
        return;
    }

    const firstSignatureHtml: SignatureBlock = {
        name: loc(defaultOwaSignatureName),
        value: legacySignature.html.value,
        secondaryKey: 'htm',
    };

    // Create first HTML signature for user in OCS
    setRoamingSignatureInStore(firstSignatureHtml);

    if (legacySignature.txt?.value) {
        const firstSignatureTxt: SignatureBlock = {
            name: loc(defaultOwaSignatureName),
            value: legacySignature.txt.value,
            secondaryKey: 'txt',
        };

        // Create first Text signature for user in OCS
        setRoamingSignatureInStore(firstSignatureTxt);
    }

    saveRoamingSignature(roamingSignatureMap);
    saveRoamingSignatureList();

    if (AutoAddSignature) {
        setDefaultSignatureName(loc(defaultOwaSignatureName), false /*isReply*/);
        saveDefaultRoamingSignature(loc(defaultOwaSignatureName));
    }
    if (AutoAddSignatureOnReply) {
        setDefaultSignatureName(loc(defaultOwaSignatureName), true /*isReply*/);
        saveDefaultReplyRoamingSignature(loc(defaultOwaSignatureName));
    }
}
